import template from './fundingObligationImportResultModal.html';
import controller from './fundingObligationImportResultModal.controller';

let FundingObligationImportResultModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

FundingObligationImportResultModalComponent.template = template;
FundingObligationImportResultModalComponent.controller = controller;

export default FundingObligationImportResultModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/fundingObligationImportResultModal/fundingObligationImportResultModal.component.js